import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { PageSectionHeader } from 'components/page';
import { HomeQuickLinksLink } from '.';

const HomeQuickLinks = () => {
  const {
    language,
    messages,
    serverConfig: { homePageQuickLinks }
  } = useReduxState();

  if (!homePageQuickLinks?.links?.length) return null;

  const description =
    homePageQuickLinks.descriptionTranslations?.[language] ||
    homePageQuickLinks.description;

  const title =
    homePageQuickLinks.titleTranslations?.[language] ||
    homePageQuickLinks.title ||
    messages.homePageModuleQuickLinksTitle;

  return (
    <div>
      <PageSectionHeader description={description} title={title} />

      <div className="links">
        {homePageQuickLinks.links.map((link, index) => (
          <div className="link" key={index}>
            <HomeQuickLinksLink link={link} />
          </div>
        ))}
      </div>

      <style jsx>{`
        .links {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          gap: 30px;
        }
        .link {
          width: 100%;
        }
        @media (min-width: ${breakpoints.small}px) {
          .link {
            width: calc(50% - 15px);
          }
        }
        @media (min-width: ${breakpoints.medium}px) {
          .link {
            width: calc(33.333% - 20px);
          }
        }
        @media (min-width: ${breakpoints.large}px) {
          .link {
            width: calc(25% - 22.5px);
          }
        }
      `}</style>
    </div>
  );
};

export default HomeQuickLinks;
